import * as querystring from 'querystring';

const arrayCheck = (arr) => {
  if (Array.isArray(arr) && arr?.length) {
    return arr;
  }
  return [];
};

const returnQueryParams = (location) =>
  querystring.parse(location?.search?.replace('?', ''));

const Utils = {
  arrayCheck,
  returnQueryParams,
};

export default Utils;
